import React, {useState, useEffect} from 'react';
//import { makeStyles } from '@material-ui/core/styles';
//import Select from '@material-ui/core/Select';
//import Select from '@material-ui/core/Select';

function CartInputSelect(props) { 
  const [ErrorMsg, setErrorMsg] = useState(() => {
    const initialState = initErrorMsg();
    return initialState;
  }); 
  
  function initErrorMsg() {
    //console.log("INIT");
     if (!props.errList || props.errList.length === 0)
      return "";
    let txt = "";
    let errList = props.errList.filter((el) => el.id === props.name);
    if (errList.length > 0) {
      errList.forEach((el) => txt += el.msg+ " ");
    }   
    const initialState = txt;
    return initialState;
  };

  useEffect(() => {
    if (ErrorMsg === "") {
      let txt = initErrorMsg();
      if (txt !== "")
        setErrorMsg(txt);
    }
  }, [props.errList]);

  function checkField(ev) {
    props.change(ev.target.value);
    setErrorMsg("");
  }

  const startingStyle = {
    border: "1px solid #B3B3B3",
  };
  const validStyle = {
    border: "1px solid green",
  };
  const invalidStyle = {
    border: "1px solid red",
  };
  function setStyle() {
    if (!props.required) return startingStyle;
    if (props.value.length === 0 && ErrorMsg.length === 0) return startingStyle;
    if (ErrorMsg.length === 0) return validStyle;
    else return invalidStyle;
  }

  function labelUrl(label, urlText, url) {
    let txt =
      label + " (<a target='_self' href='" + url + "'>" + urlText + "</a>)";
    return { __html: txt };
  }

  function composeLabel(labelTxt) {
    if (props.url && props.url.length > 0) {
      return (
        <label
          dangerouslySetInnerHTML={labelUrl(labelTxt, props.urlText, props.url)}
        />
      );
    } else return <label>{labelTxt}</label>;
  }

  let label = props.lbl;
  if (props.required === true && label.length > 0) 
    label += " *";

  if ((props.hideIfEmpty === true) && (props.options.length === 0))
    return null;

  return (
    <>
      <div className={props.cssClass}>
        {props.labelRight === true ? null : composeLabel(label)}

        <select
          name={props.name}
          value={props.value}
          onChange={(e) => checkField(e)}
          style={setStyle()}
        >
          {props.options.length === 0 ? (
            <option value="0" key="op_0">
              {" "}
            </option>
          ) : null}
          {props.emptyOption && props.emptyOption.length >= 2 ? (
            <option value={props.emptyOption[0]} key={"op_empty"}>
              {props.emptyOption[1]}
            </option>
          ) : null}
          {props.options.map((el) => (
            <option value={el[props.valName]} key={"op_" + el[props.valName]}>
              {props.composeText(el)}
            </option>
          ))}
        </select>

        {props.labelRight === true ? composeLabel(label) : null}

        {ErrorMsg.length > 0 ? (
          <div
            className={
              props.labelRight === true ? "errore_cart" : "campo_vuoto_cart"
            }
          >
            <p>{ErrorMsg}</p>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default CartInputSelect;